import React, { memo, useContext, useEffect, useState } from 'react'
import Link from 'next/link'
import { Vbox } from '../../components/layout/Box'
import { Button, Typography, Paper, Input, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ForwardThumbnail from '../../lib/react-storefront/ForwardThumbnail'
import Image from '../../lib/react-storefront/Image'
import clsx from 'clsx'
import ProductOptionSelector from '../../components/option/ProductOptionSelector'
import * as yup from 'yup'
import SessionContext from '../../contexts/SessionContext'
import { useRouter } from 'next/router'
import Grid from '@material-ui/core/Grid'
import PhotoCamera from '@material-ui/icons/PhotoCamera'
import isEmpty from 'lodash/isEmpty'
import AddToCartConfirmation from '../../components/product/AddToCartConfirmation'
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import get from 'lodash/get'
import AlertComponent from '../Alert'
const CryptoJS = require('crypto-js')
const validationSchema = yup.object({
  image: yup.mixed().required('Image is required'),
})
import CreateIcon from '@material-ui/icons/Create'
const useStyles = makeStyles(theme => ({
  root: {
    padding: `${theme.spacing(2)}px 0`,
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(1)}px 0`,
    },
    [theme.breakpoints.down('xs')]: {
      padding: `${theme.spacing(0)}px 0`,
    },
  },
  thumbnail: {
    marginBottom: theme.spacing(1),
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
  price: {
    marginTop: '5px',
    fontWeight: 'bold',
  },
  reviews: {
    marginTop: '5px',
  },
  reviewCount: {
    marginLeft: '2px',
  },
  info: {
    margin: '0',
  },
}))

function ProductItem({ product, index, classes, className, colorSelector = true, addToCartInProgress, setAddToCartInProgress }) {
  classes = useStyles({ classes })
  const [store, updateStore] = useState(product)
  const [file, setFile] = useState('')
  const color = {}
  const size = !isEmpty(store?.size) ? store.sizes[0] : {}
  const mod = !isEmpty(store?.mods) ? store.mods[0] : {}
  const quantity = 1
  const { actions, config, session } = useContext(SessionContext)
  const [currentItemInProgress, setCurrentItemInProgress] = useState(false)
  const [confirmationOpen, setConfirmationOpen] = useState(false)
  const [nameEdit, setNameEdit] = useState(false)
  const [productName, setProductName] = useState('')
  const [productError, setProductError] = React.useState(null)
  const [catgroup, setCatGroup] = React.useState(product.catgroupid)
  const [category, setCategory] = React.useState(product.categoryid)
  const [subcategory, setSubcategory] = React.useState(product.subcategoryid)
  const [currentCategories, setCurrentCategories] = React.useState([])
  const [currentsubcategories, setCurrentSubcategory] = React.useState([])
  const [currentsizes, setCurrentSizes] = React.useState([])
  const [currentsize, setCurrentSize] = React.useState(product.sizeid)
  const errorType = 'error'
  const handleCloseError = () => {
    setProductError(null)
  }
  const handleCatGroupChange = e => {
    setCatGroup(e.target.value)
    let catid = e.target.value
    setCategory('')
    setSubcategory('')
    setCurrentCategories([])
    setCurrentSubcategory([])
    // let catfound = false
    if (session.hasOwnProperty('categories')) {
      for (let index in session.categories) {
        const catgroup = session.categories[index]
        if (catgroup.id == catid) {
          setCurrentCategories(catgroup.categories)
          break
        }
      }
    }
  }
  const handleCatChange = e => {
    setCategory(e.target.value)
    let catid = e.target.value
    setSubcategory('')
    setCurrentSubcategory([])

    for (let index in currentCategories) {
      const category = currentCategories[index]
      if (category.id == catid) {
        setCurrentSubcategory(category.subcategories)
        break
      }
    }
  }
  const handleSubCatChange = e => {
    setSubcategory(e.target.value)
  }
  const handleSizeChange = e => {
    setCurrentSize(e.target.value)
  }
  const submitCategory = () => {
    window
      .fetch({
        method: 'post',
        body: JSON.stringify({
          catgroup,
          category,
          subcategory,
          code: product.code,
          sizeid: currentsize,
          productId:product.id
        }),
        url: '/maintenance/changecategory/' + storeSlug,
        headers: {
          'Content-type': 'application/json',
        },
      })
      .then(res => {
        alert('Category updated.')
      })
      .catch(e => {
        alert('Something went wrong! Please try again.')
      })
  }

  useEffect(() =>{
      updateStore(product)
      setCurrentSize(product.sizeid)
      setCatGroup(product.catgroupid)
      setCategory(product.categoryid)
      setSubcategory(product.subcategoryid)

      if (session.hasOwnProperty('categories')) {
        for (let index in session.categories) {
          const catgroup = session.categories[index]
          if (catgroup.id == product.catgroupid) {
            setCurrentCategories(catgroup.categories)
            for (let catindx in catgroup.categories) {
              const category = catgroup.categories[catindx]
              if (category.id == product.categoryid) {
                setCurrentSubcategory(category.subcategories)
                break
              }
            }
            break
          }
        }
      }

      if (session.hasOwnProperty('sizes')) {
        for (let index in session.sizes) {
          setCurrentSizes(session.sizes)
        }
      }
    },
    [product, session.categories]
  )

  useEffect(() => {
    let items = get(session, 'cart.items') ? get(session, 'cart.items') : []
    if (!items.length > 0) {
      if (localStorage.getItem('defaulttip') != null) {
        localStorage.removeItem('defaulttip')
      }
    }
  }, [])

  const router = useRouter()
  let { storeSlug } = router.query
  // Adds an item to the cart
  const addToCart = async event => {
    setAddToCartInProgress(true) // disable the add to cart button until the request is finished
    setCurrentItemInProgress(true)
    try {
      // send the data to the server
      await actions.addToCart({
        product,
        quantity,
        color: color.id,
        size: size.id,
        mod: mod,
      })
      // open the confirmation dialog
      setConfirmationOpen(true)
    } catch (e) {
      setProductError(e.message)
    } finally {
      // re-enable the add to cart button
      setAddToCartInProgress(false)
      setCurrentItemInProgress(false)
    }
  }
  const onSubmit = e => {
    e.stopPropagation()
    e.preventDefault()
    if (product.code.length == 0) {
      alert('This item does not have any stock code')
      return false
    }
    if (!file) {
      alert('Please select File First')
      return false
    }
    if (confirm('This operation is irreversable, do you want to continue?')) {
      const formData = new FormData()
      formData.append('storeSlug', storeSlug)
      formData.append('code', product.code && product.code.length > 0 ? product.code[0].code : [])
      formData.append('image', file)
      formData.append( 'productId',product.id)
      window
        .fetch({
          method: 'post',
          body: formData,
          url: '/maintenance/uploadimage/' + storeSlug,
        })
        .then(res => {
          alert(
            'image upload success, it may not appear on your browser even after refresh because of the caching files'
          )
          let newStore = { ...store }
          res.json().then(data => {
            newStore.thumbnail.src = data.url + '/400'
            updateStore(newStore)
          })
        })
        .catch(e => {
          alert('Something went wrong! Please try again. if it happens again try with other image')
        })
    }

    return false
  }
  const onRemove = e => {
    if (!product.code) {
      alert('This item does not have any stock code')
    }
    if (confirm('This operation is irreversable, do you want to continue?')) {
      window
        .fetch({
          method: 'post',
          body: JSON.stringify({code: product.code , 'productId':product.id}),
          url: '/maintenance/removeimage/' + storeSlug,
          headers: {
            'Content-type': 'application/json',
          },
        })
        .then(res => {
          if (res.status == '200') {
            alert(
              'image removal success, it may not appear on your browser even after refresh because of the caching files'
            )
            let newStore = { ...store }
            res.json().then(data => {
              updateStore(newStore)
            })
          } else {
            alert(
              'Something went wrong! Please try again. if it happens again try with other image'
            )
          }
        })
        .catch(e => {
          alert('Something went wrong! Please try again. if it happens again try with other image')
        })
    }

    return false
  }
  const onChange = event => {
    setFile(event.currentTarget.files[0])
  }
  return (
    <div id={`item-${index}`} className={clsx(className, 'box', classes.root)}>
      <Vbox alignItems="stretch">
        <Paper elevation={3} variant="outlined">
          <AlertComponent message={productError} type={errorType} close={handleCloseError} hideTime={6}/>
          <ForwardThumbnail>
            <Link
              as={product.url}
              href="/store/[storeSlug]/p/[productId]"
              className={classes.link}
              // prefetch="visible"
              pageData={{ product, color: store.color }}
            >
                <Image
                  className={classes.thumbnail}
                  fill={true}
                  src={
                    (store.color && store.color.media.thumbnail.src) ||
                    (store.thumbnail && store.thumbnail.src)
                  }
                  alt={
                    (store.color && store.color.media.thumbnail.alt) ||
                    (store.thumbnail && store.thumbnail.alt)
                  }
                  optimize={{ maxWidth: 200 }}
                  lazy={index >= 4 && index < 20 ? 'ssr' : false}
                  aspectRatio={1}
                />
            </Link>
          </ForwardThumbnail>
          <div className={classes.info}>
            {product?.name && (
            <Typography align="center" variant="subtitle1" className={classes.name}>
              {!nameEdit ? (
                product.name.length > 40 ? (
                  product.name.substring(0, 40) + '...'
                ) : (
                  product.name
                )
              ) : (
                <Input
                  onChange={e => {
                    setProductName(e.target.value)
                  }}
                  value={productName}
                ></Input>
              )}{' '}
              {session.image_edit_allowed ? (
                !nameEdit ? (
                  <CreateIcon
                    onClick={() => {
                      setProductName(product.name)
                      setNameEdit(true)
                    }}
                  ></CreateIcon>
                ) : (
                  <CheckCircleIcon
                    onClick={() => {
                      setNameEdit(false)
                      if (productName != '') {
                        window
                          .fetch({
                            method: 'post',
                            body: JSON.stringify({ name: productName, code: product.code, productId:product.id }),
                            url: '/maintenance/changename/' + storeSlug,
                            headers: {
                              'Content-type': 'application/json',
                            },
                          })
                          .then(res => {
                            alert('Name updated.')
                          })
                          .catch(e => {
                            alert('Something went wrong! Please try again.')
                          })
                      }
                    }}
                  ></CheckCircleIcon>
                )
              ) : (
                ''
              )}
            </Typography>
            )}
            {colorSelector && (
              <ProductOptionSelector
                options={store.colors}
                value={store.color}
                onChange={value => updateStore({ ...store, color: value })}
                optionProps={{
                  size: 'small',
                  showLabel: false,
                }}
              />
            )}

            <Typography align="center" className={classes.price}>
              {product.priceText}
            </Typography>
            {session.image_edit_allowed ? (
              <Typography>
                {product.code ? product.code.map(code => code.code + ', ') : ''}
              </Typography>
            ) : (
              ''
            )}
          </div>

          <AddToCartConfirmation
            open={confirmationOpen}
            setOpen={setConfirmationOpen}
            product={product}
            color={color}
            size={size}
            mod={mod}
            quantity={quantity}
            price={store.priceText}
          />

          {(product?.stocklevel > 0 || ( config?.outofstock == 'ignoreinventorylevel')) && (
            <Button
              key="button"
              onClick={addToCart}
              variant="contained"
              color="primary"
              size="small"
              data-th="add-to-cart"
              style={{ float: 'right', borderRadius: '29px 0px 0px 29px' }}
              className={clsx(classes.docked, classes.noShadow)}
              disabled={addToCartInProgress}
            >
              {currentItemInProgress ? <CircularProgress size={'24px'} color="secondary" /> : <AddShoppingCartIcon/>}
            </Button>
          )}
          {session.image_edit_allowed ? (
            <div className="">
              <form onSubmit={onSubmit}>
                <div className="">
                  <Input
                    style={{ display: 'none' }}
                    accept="image/*"
                    onChange={onChange}
                    name="image"
                    type="file"
                    id={'icon-button-file' + product.id}
                  ></Input>
                  <label htmlFor={'icon-button-file' + product.id} title="Upload File">
                    <Button
                      style={{ borderRadius: '0px 29px 29px 0px' }}
                      variant="contained"
                      size="small"
                      color="primary"
                      aria-label="upload picture"
                      component="span"
                    >
                      <PhotoCamera />
                    </Button>
                  </label>
                </div>
                <Grid
                  justify="space-between"
                  container
                  spacing={24}
                  className="p-1"
                >
                  <Grid item>
                    {' '}
                    <Button type="submit" className="" variant="contained" color="primary">
                      Submit
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button align="right" variant="contained" color="secondary" onClick={onRemove}>
                      X
                    </Button>
                  </Grid>
                </Grid>
              </form>
              <form>
                <FormControl fullWidth size="small" className={classes.formControl}>
                  <InputLabel id="demo-simple-select-helper-label" className="l-7">
                    Category group
                  </InputLabel>
                  <Select
                    className="pl-7"
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={catgroup}
                    onChange={handleCatGroupChange}
                  >                    
                    {  (session != undefined && session?.categories && session.categories != undefined) &&  session.categories.map((value, index) => (
                          <MenuItem value={value.id}>{value.name}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
                <FormControl fullWidth size="small" className={classes.formControl}>
                  <InputLabel id="demo-simple-select-helper-label" className="l-7">
                    Category{' '}
                  </InputLabel>
                  <Select
                    className="pl-7"
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={category}
                    onChange={handleCatChange}
                  >
                    {currentCategories
                      ? currentCategories.map((value, index) => (
                          <MenuItem value={value.id}>{value.name}</MenuItem>
                        ))
                      : ''}
                  </Select>
                </FormControl>
                <FormControl fullWidth size="small" className={classes.formControl}>
                  <InputLabel id="demo-simple-select-helper-label" className="l-7">
                    SubCategory
                  </InputLabel>
                  <Select
                    className="pl-7"
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={subcategory}
                    onChange={handleSubCatChange}
                  >
                    {currentsubcategories
                      ? currentsubcategories.map((value, index) => (
                          <MenuItem value={value.id}>{value.name}</MenuItem>
                        ))
                      : ''}
                  </Select>
                </FormControl>
                <FormControl fullWidth size="small" className={classes.formControl}>
                  <InputLabel id="demo-simple-select-helper-label" className="l-7">
                    Size
                  </InputLabel>
                  <Select
                    className="pl-7"
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={currentsize}
                    onChange={handleSizeChange}
                  >
                    {currentsizes
                      ? currentsizes.map((value, index) => (
                          <MenuItem value={value.id}>{value.name}</MenuItem>
                        ))
                      : ''}
                  </Select>
                </FormControl>
                <Button onClick={submitCategory} fullWidth size={'small'} variant={'contained'}>
                  Submit
                </Button>
              </form>
            </div>
          ) : null}
        </Paper>
      </Vbox>
    </div>
  )
}

export default memo(ProductItem)